export const objectFromEntries = (entries) => entries.reduce((acc, el) => {
    acc[el[0]] = el[1];
    return acc;
}, {});
export const objectEntries = (o) => {
    const entries = [];
    for (const prop in o) {
        entries.push([prop, o[prop]]);
    }
    return entries;
};
export const objectValues = (o) => {
    const entries = [];
    for (const prop in o) {
        entries.push(o[prop]);
    }
    return entries;
};
/**
 * Очередь
 * @example
 * ```
 * const values: [number, number, number] = [1, 2, 3];
 * const list = new LinkedList(values);
 *
 * values.forEach((v, i) => {
 *    test(`${i}-й вызов next возвращает элемент ${v} из [${values}]`, () => {
 *       expect(list.current).toBe(v);
 *       list.next();
 *    });
 * });
 *
 * test('после последнего текущий элемент - null ', () => {
 *    expect(list.current).toBe(null);
 * });
   ```
 */
export class Queue {
    constructor(data) {
        this.data = data;
        this.cursor = 0;
    }
    /**
     * Возращает текущий элемент или null
     * @returns {T|null}
     */
    get current() {
        return this.data[this.cursor] || null;
    }
    /**
     * Перевести курсор на следующий элемент
     * @void
     */
    next() {
        if (this.cursor === this.data.length) {
            return;
        }
        this.cursor++;
    }
    /**
     * В начало очереди
     * @void
     * @example
     * ```
     * const values: [number, number, number] = [5, 6, 7];
     * const list = new Queue(values);
     *
     * for (let i = 0; i < 5; i++) { list.next(); }
     *
     * list.reset();
     *
     * values.forEach((v, i) => {
     *    test(`${i}-й вызов next возвращает элемент ${v} из [${values}]`, () => {
     *        expect(list.current).toBe(v);
     *        list.next();
     *    });
     * });
     * ```
     */
    reset() {
        this.cursor = 0;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/base/lib.js